module.exports = __webpack_public_path__ + "img/4.6761ec25.jpg";